import {
  PayableStatus,
  SearchPayableRowsFilterParameter
} from "@wingspanhq/wingspan-api-sdk";
import { PAYABLES_NOT_DECLINED_CLAUSE } from "../components/TablePayables/filters/statusOptions";

export const selectorDashboardSummaryFilters = (
  overdueBefore: Date
): Record<"open" | "overdue", SearchPayableRowsFilterParameter> => {
  const baseFilter: SearchPayableRowsFilterParameter = {
    metadata_invoiceType: { ne: "approvedInvoicesPayment" },
    metadata_creationSource: { ne: "personalPaylink" },
    status: { anyOf: [PayableStatus.OPENED] },
    payerApprovalStatus: PAYABLES_NOT_DECLINED_CLAUSE
  };

  return {
    open: {
      ...baseFilter,
      status: { anyOf: [PayableStatus.OPENED, PayableStatus.PENDING] }
    },
    overdue: { ...baseFilter, dueDate: { lt: overdueBefore } }
  };
};
